// Bileli: Kyrgyz overlay for the PRE-LOGIN auth screens — why: there is no Telegram 'ky' langpack, so
// setSharedSettingOption({ language: 'ky' }) could never localize these screens (keys would fall back to
// the English fallback.strings). Instead the auth screens keep Telegram's engine for RU (the default,
// fetched from the API) and swap in these strings directly when the BILELI language is Kyrgyz. Scope is
// deliberately the two entry screens (phone + QR) + the promo panel; the transient code/password screens
// stay on the Telegram engine (follow-up if ever needed).
import { bileliLangStore } from '../../bileli/shared/i18n/langStore';
import { useStoreState } from '../../bileli/shared/lib/zustandTeact';

export interface BileliAuthKyStrings {
  startText: string;
  loginPhonePlaceholder: string;
  authKeepSignedIn: string;
  loginNext: string;
  loginQrLogin: string;
  loginQrTitle: string;
  loginQrHelp1: string;
  loginQrHelp2: string;
  loginQrHelp3: string;
  loginQrCancel: string;
  promoHeadline1: string;
  promoHeadline2: string;
  promoAccent: string;
  promoSub: string;
}

// Keyed 1:1 to the fallback.strings keys each site renders (see AuthPhoneNumber/AuthQrCode).
// LoginQRHelp2 is PLAIN text here (no **bold** markers) — the overlay bypasses lang()'s markdown pass.
const KY: BileliAuthKyStrings = {
  startText: 'Өлкө кодун ырастап, телефон номериңизди киргизиңиз.',
  loginPhonePlaceholder: 'Телефон номериңиз',
  authKeepSignedIn: 'Аккаунтта калуу',
  loginNext: 'Улантуу',
  loginQrLogin: 'QR-код аркылуу кирүү',
  loginQrTitle: 'Bileliге QR-код аркылуу кирүү',
  loginQrHelp1: 'Телефонуңузда Telegram колдонмосун ачыңыз',
  loginQrHelp2: 'Баптоолор → Түзмөктөр → Түзмөк кошуу бөлүмүнө өтүңүз',
  loginQrHelp3: 'Кирүүнү ырастоо үчүн телефонуңузду бул экранга багыттаңыз',
  loginQrCancel: 'Телефон номери менен кирүү',
  promoHeadline1: 'Үйрөт.',
  promoHeadline2: 'Үйрөн.',
  promoAccent: 'Өс.',
  promoSub: 'Кыргыз жана орус тилдеринде окуу жана окутуу платформасы.',
};

/** Returns the Kyrgyz strings when the Bileli language is 'ky', undefined for 'ru' (Telegram engine). */
export function useBileliAuthKy(): BileliAuthKyStrings | undefined {
  const lang = useStoreState(bileliLangStore, (s) => s.lang);
  return lang === 'ky' ? KY : undefined;
}
